@import "~@govbr-ds/core/src/components/breadcrumb/breadcrumb";
@import "~@govbr-ds/core/src/partial/scss/configs/icons";
@import "~@govbr-ds/core/src/components/button/button";
@import "~@govbr-ds/core/src/components/list/list";
@import "~@govbr-ds/core/src/components/item/item";
@import "~@govbr-ds/core/src/components/divider/divider";

:host {
  display: block;
}

.br-breadcrumb {
  .br-icon {
    color: #ccc;
  }

  .br-icon,
  .mobile-active-page {
    display: flex;
    align-items: center;
  }

  .mobile-crumb-list {
    display: none;
    position: absolute;
    width: 200px;
    box-shadow: var(--surface-shadow-sm);
  }

  .mobile-crumb-list.show {
    display: block;
    top: 100%;
    z-index: 999;
  }

  .buttonFolderGroup,
  .buttonFolderGroup span {
    display: flex;
    align-items: center;
  }

  .mobile-active-page {
    span:focus:focus-visible {
      outline: var(--focus-width) var(--focus-style) var(--focus);
      outline-offset: var(--focus-offset);
    }

    [data-active] {
      margin: 0 var(--spacing-scale-2x) 0 var(--spacing-scale-base);
    }
  }

  .crumb {
    display: flex;
    align-items: center;

    span {
      display: flex;
      align-items: center;
    }
  }
}

.tooltip-box {
  position: fixed;
  background: #1351b4;
  color: #fff;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  transform: translate(-50%, -100%);
  pointer-events: none;
  z-index: 9999;
  box-shadow: 0 2px 4px rgb(0 0 0 / 20%);
  opacity: 0;
  transition: opacity 0.2s ease-in-out;

  &::after {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #1351b4;
  }
}

:host(:hover) {
  .tooltip-box {
    opacity: 1;
  }
}
